// .env values are copied from Angular's environment.ts which uses trailing
// commas (e.g. value: 'abc',). CRA's dotenv only strips wrapping quotes when the
// last char IS a quote — the trailing comma breaks that check, so the raw value
// can arrive as `'https://...',`. Strip surrounding quotes and an optional
// trailing comma so concatenated URLs stay valid. (Mirrors cryptoService.ts.)
const stripEnvValue = (val: string | undefined): string =>
  (val ?? '').replace(/^['"]/, '').replace(/['"],?$/, '');

export const ENV_CONFIG = {
  php1Url: process.env.REACT_APP_API_apiUrlemis1 ?? '',
  php3Url: process.env.REACT_APP_API_apiUrlemis3 ?? '',
  djangoTnEmisUrl: process.env.REACT_APP_API_apiUrlTnEmisDjango ?? '',
  djangoEmisUrl: process.env.REACT_APP_API_apiUrlEmisDjango ?? '',
  phpTntpUrl: process.env.REACT_APP_API_apiBaseUrlTntp ?? '',
  emisLoginUrl: process.env.REACT_APP_API_loginApiBaseUrl ?? '',
  djangoTntpUrl: process.env.REACT_APP_API_apiUrlTntpDjango ?? '',
  djangoSupportUrl: process.env.REACT_APP_API_apiUrlSupportDjango ?? '',
  loginApiUrl: process.env.REACT_APP_API_apiUrlLoginApi ?? '',
  readingFileApi: process.env.REACT_APP_API_readingFileApi ?? '',
  // Pre-signed S3 upload URL generator.
  getSignedUrlApi: process.env.REACT_APP_API_getSignedUrlApi ?? '',
  // S3 metadata cleaner — endpoint for uploading small (<5MB) files as base64.
  metaClean: stripEnvValue(process.env.REACT_APP_API_metaClean),
  // Large-file upload (multipart) — EC2 upload endpoint. Falls back to the
  // known URL if the env var isn't loaded (e.g. dev server not restarted).
  largeFileUploadApi:
    stripEnvValue(process.env.REACT_APP_API_largeFileUploadApi) ||
    'https://metaemis-ec2upload.tnsed.com/upload',
  // Signed-URL API for S3 uploads (transfer document upload).
  signedUrlApi: stripEnvValue(process.env.REACT_APP_API_getSignedUrlApi),
  // g2c base — bonafide e-sign + esevai download.
  g2cUrl: stripEnvValue(process.env.REACT_APP_API_apibaseurlg2c),
  // SLAS 2024-25 integration target; differs per environment (local/staging/prod).
  slasSiteURL: stripEnvValue(process.env.REACT_APP_API_slasSiteURL),
  // Deployment environment: LOCAL | STAGING | PRODUCTION.
  environment: stripEnvValue(process.env.REACT_APP_API_environment),
  // App menu is served as a static nested JSON on CloudFront. Local + staging
  // share the staging file; production uses the prod file.
  appMenuUrl:
    stripEnvValue(process.env.REACT_APP_API_environment) === 'PRODUCTION'
      ? 'https://d1wpyxz35bzzz4.cloudfront.net/emis_appmenu_new-json-prod.json'
      : 'https://d1wpyxz35bzzz4.cloudfront.net/emis_appmenu_new-json-staging.json',
};

export default ENV_CONFIG;
